module.exports = __webpack_public_path__ + "static/media/platre.61e38574.png";